import { useState, useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import {
    svc_plaid_createLinkToken,
    svc_plaid_exchangePublicToken,
    svc_plaid_getAccounts,
    svc_plaid_getAccountBalances,
    svc_plaid_getTransactions,
    svc_plaid_getLiabilities,
} from '../services/external-plaid.service';

const PlaidIntegration = () => {
    // Tokens
    const { user, getAccessTokenSilently } = useAuth0();
    const [linkToken, setLinkToken] = useState(null);

    // Data
    const [itemId, setItemId] = useState(null);
    const [accounts, setAccounts] = useState(null);
    const [balances, setBalances] = useState(null);
    const [liabilities, setLiabilities] = useState(null);
    const [transactions, setTransactions] = useState(null);

    useEffect(() => {
        const fetchLinkToken = async () => {
            const auth0Token = await getAccessTokenSilently();
            const { data }   = await svc_plaid_createLinkToken(auth0Token, user?.sub);
            setLinkToken(data.link_token);
        };
        fetchLinkToken();
    }, []);

    const config = {
        token: linkToken,
        onSuccess: async (publicToken) => {
            const auth0Token = await getAccessTokenSilently();
            const { data }   = await svc_plaid_exchangePublicToken(auth0Token, publicToken, user?.sub);

            setItemId(data.item_id);
        },
    };
    
    const { open, ready } = usePlaidLink(config);

    const getAccounts = async () => {
        const auth0Token = await getAccessTokenSilently();
        const { data } = await svc_plaid_getAccounts(auth0Token, user.sub, itemId);
        setAccounts(data.accounts);
        // data.accounts.forEach(account => {
        //     svc_createPlaidItem(auth0Token, user.sub, account.account_id);
        // });
    };

    const getBalances = async () => {
        const auth0Token = await getAccessTokenSilently();
        const { data }   = await svc_plaid_getAccountBalances(auth0Token, user.sub, itemId);
        setBalances(data.balances);
    }

    const getLiabilities = async () => {
        const auth0Token = await getAccessTokenSilently();
        const { data }   = await svc_plaid_getLiabilities(auth0Token, user.sub, itemId);
        setLiabilities(data.liabilities);
    }

    const getTransactions = async () => {
        const auth0Token = await getAccessTokenSilently();
        const { data }   = await svc_plaid_getTransactions(auth0Token, user.sub, itemId);
        setTransactions(data.transactions)
    }

    return (
        <div>
            <h3>Connect a Bank</h3>

            {linkToken ? (
                <button
                    className="button button-blue"
                    onClick={open}
                    disabled={!ready}
                >
                    Launch Plaid
                </button>
            ) : <LoadingSpinner />}

            {itemId && (
                <>
                    <DataGroup
                        data={accounts}
                        title="Accounts"
                        fetchMethod={getAccounts}
                    />
                    <DataGroup
                        data={balances}
                        title="Balances"
                        fetchMethod={getBalances}
                    />
                    <DataGroup
                        data={liabilities}
                        title="Liabilities"
                        fetchMethod={getLiabilities}
                    />
                    <DataGroup
                        data={transactions}
                        title="Transactions"
                        fetchMethod={getTransactions}
                    />
                </>
            )}
        </div>
    );
};

export default PlaidIntegration;

const DataGroup = ({
    data,
    title,
    fetchMethod
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div>
            {data ? <div className="spc-p-1" style={{
                border: '1px solid #d1d5db',
                margin: '2rem 0',
                backgroundColor: '#fcfcfd',
            }}>
                <h3
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{
                        cursor: 'pointer',
                        margin: '0',
                    }}
                >
                    {title} [{isExpanded ? '-' : '+'}]
                </h3>
                {isExpanded && <div className="spc-m-t-1"><pre>{JSON.stringify(data, null, 2)}</pre></div>}
            </div> : (
                <button
                    className="button button-green"
                    onClick={fetchMethod}
                >
                    Fetch {title}
                </button>
            )}
        </div>
    );
}